import { createSelector } from 'reselect'
import { getCurrentProfileSelect } from '../get-current'
import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

export const getDailyFatIntakePercentageGoalProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.DAILY_FAT_INTAKE_PERCENTAGE_GOAL)
)
